import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/vars';
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/screen-size';

  .MoneyCell__inner {
    height: rem(45px);
    display: flex;
    align-items: center;

    :global(.Tooltip__text) {
      display: flex !important;
      align-items: center;
      flex-wrap: wrap;
    }

    :global(span) {
      font-size: rem(16px);
      line-height: 1;
      &:first-child {
        margin: 0 !important;
        color: #000;
      }
    }

    .currency {
      margin-left: 5px;
    }

    &.inTable {
      height: 40px;
      flex-wrap: wrap;
      @include respond-to(sm) {
        height: 30px;
        position: relative;
        bottom: 1px;
      }
      :global(span) {
        &:first-child {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    &.crmStyle {
      color: #333;

      /* body/14/medium */
      font-family: $ubuntu-font !important;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%; /* 19.6px */
      :global(span) {
        color: #333;

        /* body/14/medium */
        font-family: $ubuntu-font !important;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%; /* 19.6px */
      }
    }

    &.heightMaxContent {
      height: max-content;
    }

    &.success {
      span {
        color: #389700 !important;
      }
    }

    &.danger {
      span {
        color: #e33046 !important;
      }
    }
  }
`;

export { staticStyles };
